const medicationEditChipSx = (selected) => ({
    minHeight: 38,
    px: 0.4,
    bgcolor: selected ? '#ffe566' : '#f3f4f6',
    color: selected ? '#5a4a00' : '#666',
    border: 'none',
    fontWeight: selected ? 700 : 600,
    fontSize: '0.95rem',
    borderRadius: '999px',
    '& .MuiChip-label': { px: 1.1 },
    '&:hover, &:focus, &.Mui-focusVisible': {
        bgcolor: selected ? '#ffd700' : '#eee',
        color: selected ? '#5a4a00' : '#666',
        border: 'none',
    },
    '&:active': {
        bgcolor: selected ? '#ffd700' : '#eee',
        color: selected ? '#5a4a00' : '#666',
        border: 'none',
    },
    '&.Mui-disabled': {
        opacity: 1,
        bgcolor: selected ? '#ffe566' : '#f3f4f6',
        color: selected ? '#5a4a00' : '#666',
        border: 'none',
    },
});

export default medicationEditChipSx;
